import { gql } from '@apollo/client';

export const UPDATE_UTILITY_ACCOUNT_DETAIL = gql`
  mutation Flex_UpdateUtilityAccountDetail(
    $utilityAccountId: Int!
    $input: UpdateUtilityAccountDetailInput!
  ) {
    updateUtilityAccountDetails(utilityAccountId: $utilityAccountId, input: $input) {
      utilityAccountDetailId
    }
  }
`;
